import { render, staticRenderFns } from "./GroupsSetting.vue?vue&type=template&id=44cbcbff&"
import script from "./GroupsSetting.vue?vue&type=script&lang=js&"
export * from "./GroupsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports